import { classnames } from '@bem-react/classnames'
import type { FC, PropsWithChildren, RefObject } from 'react'

import { AnimatedPopover } from '../../../AnimatedPopover'
import type { HeaderBlockPosition } from '../HeaderBlocks'
import { internalClassName } from './constants'
import css from './HeaderTinyPopover.css'

type HeaderTinyPopoverProps = {
  className?: string
  position: HeaderBlockPosition
  anchorRef: RefObject<HTMLElement>
  isOpen: boolean
}

export const HeaderTinyPopover: FC<PropsWithChildren<HeaderTinyPopoverProps>> = ({
  position,
  className,
  anchorRef,
  children,
  isOpen,
}) => {
  const direction = placePopover(position)

  return (
    <AnimatedPopover
      className={classnames(internalClassName, className, css.container)}
      direction={direction}
      offset="xs"
      anchorRef={anchorRef}
      isOpen={isOpen}>
      {children}
    </AnimatedPopover>
  )
}

const placePopover = (position: HeaderBlockPosition) => {
  switch (position) {
    case 'left':
      return 'downStartLeft'
    case 'center':
      return 'downCenter'
    case 'right':
      return 'downStartRight'
  }
}
